// 内容首页
import index from '@/views/content/index.vue';

export default [{
	path: '/content',
	name: 'contindex',
	component: index,
	meta: {
		// 用户权限
		// auth: '2',
		requireAuth: false,
		title: '内容'
	}
}]
